// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 345739417
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

@Injectable({
  providedIn: 'root',
})
export class AboutApiService {
  constructor(protected http: HttpClient) {}

  getAboutDetails(): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/core/About`;
    return this.http.get<any>(url);
  }
}
